import loggingService from 'common/logging/loggingService';
import React, { ErrorInfo } from 'react';

import './ErrorBoundary.scss';
import { appInsights } from 'common/logging/appInsights';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

interface ErrorBoundaryProps {
    children: any;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: any) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        loggingService.error('Error loading child component', error);
        appInsights.trackException({
            error: error,
            exception: error,
            severityLevel: SeverityLevel.Error,
            properties: errorInfo
        })
    }

    render() {
        if (this.state.hasError) {
            return <div className="error-boundary">
                <img src="/images/component-error.svg" className="component-error-image" />
                <p className="error-boundary-text">An error has occurred while loading the component</p>
            </div>;
        }

        return this.props.children;
    }
}